//
//
//
//
//

  import { Request } from '@/utils';

  const defaultHeaderImg = 'https://s.blibee.net/res/blibee-app/image/takeout/takeawayBanner.jpg';
  export default {
    props: ['bannerParam', 'showBannerIndex', 'defaultHeaderImg'],
    data() {
      return {
        bannerList: [],
      };
    },

    computed: {
      headerImg() {
        if (this.showBannerIndex === '') return '';
        if (this.bannerList.length === 0) return '';
        return this.bannerList[this.showBannerIndex].imgUrl;
      },
    },

    mounted() {
      const url = '/cvs/notify/app/banner/v4';
      const params = {
        adLocations: [],
        cityCode: '',
        shopId: 0,
        shopCode: '',
        ...this.bannerParam,
      };
      Request.post(url, params).then((res) => {
        if (params.adLocations[0] && res.data[params.adLocations[0]]) {
          const bannerList = res.data[params.adLocations[0]].adItems || [];
          if (bannerList.length > 0) {
            this.$emit('receiveParams', bannerList);
          }
          if (bannerList.length === 0) {
            bannerList.push({ imgUrl: this.defaultHeaderImg || defaultHeaderImg });
          }
          this.bannerList = bannerList;
        }
      }).catch(() => {
      // we.showToast({ title: '网络繁忙，请稍后重试', duration: 5000, icon: 'none' });
      });
    },
};



// WEBPACK FOOTER //
// ./src/components/HeaderBanner/index.vue